module.exports = __webpack_public_path__ + "static/media/syun_defaultd459131fb472b1c8c49b04f600b5c2bd.webp";